const NAMESPACE = "formTitleSubtitle";

const KEYS = {
    titleInputPlaceholderText: "titleInputPlaceholderText",
    titleEditButtonAriaLabel: "titleEditButtonAriaLabel",
    defaultDisplayTitleText: "defaultDisplayTitleText",

    subtitleInputPlaceholderText: "subtitleInputPlaceholderText",
    subtitleEditButtonAriaLabel: "subtitleEditButtonAriaLabel",
    defaultDisplaySubtitleText: "defaultDisplaySubtitleText",

    closeEditorButtonLabel: "closeEditorButtonLabel"
};

const MESSAGES = {
    [KEYS.titleInputPlaceholderText]: {
        value: "Enter Title",
        comment: "Text that appears in the input where users enter a form's title."
    },
    [KEYS.titleEditButtonAriaLabel]: {
        value: "Edit Title",
        comment: "Label of button that appears near the form title that allows the user to edit that title."
    },
    [KEYS.defaultDisplayTitleText]: {
        value: "Form Title (Optional)",
        comment: "Default form title if user has not edited the form's title yet."
    },
    [KEYS.subtitleInputPlaceholderText]: {
        value: "Enter Subtitle",
        comment: "Text that appears in the input where users enter a form's subtitle."
    },
    [KEYS.subtitleEditButtonAriaLabel]: {
        value: "Edit Subtitle",
        comment: "Label of button that appears near the form title that allows the user to edit that subtitle."
    },
    [KEYS.defaultDisplaySubtitleText]: {
        value: "Form Subtitle (Optional)",
        comment: "Default form subtitle if user has not edited the form's subtitle yet."
    },
    [KEYS.closeEditorButtonLabel]: {
        value: "Close",
        comment: "Label for button that closes the inline editor for title or subtitle text."
    }
};

export { KEYS, NAMESPACE, MESSAGES };
